import React, { useEffect, useState } from 'react';

const BALLOON_COLORS = [
  '#FF6B6B', // Red
  '#4ECDC4', // Teal
  '#FFE66D', // Yellow
  '#95E1D3', // Mint
  '#F38181', // Coral
  '#AA96DA', // Purple
  '#FCBAD3', // Pink
  '#A8D8EA', // Light Blue
];

function Balloon({ color, delay, left }) {
  return (
    <div
      className="absolute bottom-0 animate-float-up pointer-events-none"
      style={{
        left: `${left}%`,
        animationDelay: `${delay}ms`,
      }}
    >
      <svg
        width="40"
        height="50"
        viewBox="0 0 40 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Balloon */}
        <ellipse cx="20" cy="18" rx="18" ry="18" fill={color} />
        {/* Highlight */}
        <ellipse cx="14" cy="12" rx="5" ry="6" fill="white" opacity="0.3" />
        {/* Knot */}
        <path d="M18 36L20 38L22 36" stroke={color} strokeWidth="2" />
        {/* String */}
        <path
          d="M20 38C20 42 18 46 20 50"
          stroke={color}
          strokeWidth="1"
          fill="none"
        />
      </svg>
    </div>
  );
}

export function BalloonCelebration({ show, onComplete }) {
  const [balloons, setBalloons] = useState([]);

  useEffect(() => {
    if (show) {
      // Generate random balloons
      const newBalloons = Array.from({ length: 20 }, (_, i) => ({
        id: i,
        color: BALLOON_COLORS[Math.floor(Math.random() * BALLOON_COLORS.length)],
        delay: Math.random() * 1000,
        left: Math.random() * 90 + 5,
      }));
      setBalloons(newBalloons);

      // Clear after animation
      const timer = setTimeout(() => {
        setBalloons([]);
        onComplete?.();
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!show && balloons.length === 0) return null;

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-50">
      {balloons.map((balloon) => (
        <Balloon
          key={balloon.id}
          color={balloon.color}
          delay={balloon.delay}
          left={balloon.left}
        />
      ))}
    </div>
  );
}
